export default __webpack_public_path__ + "static/media/xp-dont-disturb-b.f7ab83eb.svg";